<!-- <p>Under Construction</p> -->

<div *ngIf="showSI">
    
    <!-- <ngx-extended-pdf-viewer [src]="'assets/helpFiles/EFS_Special_Ins_Userguide.pdf'" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer> -->
    <iframe src="assets/Basic_Template/EFS_Special_Ins_Userguide.pdf" width="100%" height="600px" style="border: none;"></iframe>

</div>

<div *ngIf="showSetupHelp">
    <h4>Hover over the name of the page you'd like to navigate to and click.</h4>
    <h4>You may also navigate using the Navigation panel on the upper left at any time.</h4>
</div>

<div *ngIf="showPH">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Prehold_Temp_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPM">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_ProductionMethod_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPT">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Plan_Temp_userguide_7_9_2025.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showPS">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Production_Temp_userguide_2_27_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showCS">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Corp_setup_userguide.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<div *ngIf="showRA">
    <br><br><br>
    <p>Showing Role admin help page</p>
    <iframe src="assets/Basic_Template/RoleAdministrationUserGuideV1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for package template -->
<div *ngIf="showPK">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Production_Temp_userguide_2_27_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for rule setup -->
<div *ngIf="showRS">
    <br><br><br>
    <iframe src="assets/Basic_Template/EFS_Rule_setup_userguide_4_17_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for national corp setup -->
<div *ngIf="showNCS">
    <br><br><br>
    <p>Showing National Corp Setup help page</p>
    <iframe src="assets/Basic_Template/NationalCorpSetupUserGuide.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for national dispatch template -->
<div *ngIf="showNDT">
    <br><br><br>
    <p>Showing National Dispatch Template help page</p>
    <iframe src="assets/Basic_Template/EFS_National_Dispatch_Template_Setup_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for client summary -->
<div *ngIf="showCLS">
    <br><br><br>
    <p>Showing Client Summary help page</p>
    <iframe src="assets/Basic_Template/EFS_Client_Summary_userguide_rev1.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>

<!-- Help page for single user setup icc -->
<div *ngIf="showSUSICC">
    <br><br><br>
    <p>Showing Single User Setup ICC help page</p>
    <iframe src="assets/Basic_Template/SingleUserSetupHelpScreenDocument.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>
<!-- Help page for A&R -->
<div *ngIf="showAR">
    <br><br><br>
    <p>Showing A&R help page</p>
    <iframe src="assets/Basic_Template/EFS_A&R_UserGuide_8_4_2026.pdf" width="100%" height="600px" style="border: none;"></iframe>
</div>